<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 10">
  <path fill="#00325E" d="m15.864 1.279-.687-.723c-.18-.181-.47-.181-.614 0L8.018 7.1 1.438.556c-.145-.181-.435-.181-.615 0l-.687.723c-.181.144-.181.434 0 .614l7.557 7.558c.18.18.434.18.614 0l7.557-7.558c.181-.18.181-.47 0-.614z"/>
</svg>
</template>